// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"bfe10b73","408":"0cf4fcfa","444":"f24feabd","571":"360d6c81","706":"c03d85dc","751":"c0288318","784":"10cc6f01","830":"40b1921d","895":"ac9b16fe"}[chunkId] + ".chunk.js";
};